var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-to-top c-pointer",on:{"click":function($event){return _vm.top()}}},[_c('img',{attrs:{"src":require("../../../public/icons/scroll-top.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }